import React, { memo, useRef, useImperativeHandle, forwardRef } from "react";
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  searchField: {
    minWidth: "300px",
    [theme.breakpoints.down('sm')]: {
      minWidth: "250px"
    }
  }
}));

const SearchBox = memo(forwardRef(({ searchQuery, onSearchChange, disabled }, ref) => {
  const classes = useStyles();
  const inputRef = useRef(null);

  useImperativeHandle(ref, () => ({
    focus: () => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    },
    isFocused: () => {
      return inputRef.current && document.activeElement === inputRef.current;
    }
  }));

  return (
    <TextField
      className={classes.searchField}
      label="Search posts..."
      variant="outlined"
      value={searchQuery}
      onChange={(e) => onSearchChange(e.target.value)}
      disabled={disabled}
      placeholder="Search titles, descriptions, and content"
      inputRef={inputRef}
    />
  );
}));

SearchBox.displayName = 'SearchBox';

export default SearchBox;